<template>
  <form-section id="agreement" :headline="this.$t('form.agreement.headline')">
    <textfield
      id="agreement_description"
      :label="$t('form.agreement.description.label')"
      :placeholder="$t('form.agreement.description.placeholder')"
      v-model="agreement.description"
      isRequired
      v-on:focus="scrollTo('#agreement_contract')"
    />
  </form-section>
</template>

<script>
import FormSection from "@/shared/components/FormSection.vue";
import Textfield from "@/shared/components/Textfield.vue";
export default {
  components: {
    FormSection,
    Textfield,
  },
  data() {
    return {
      agreement: {
        description: "",
      },
    };
  },
  watch: {
    agreement: {
      handler() {
        this.$store.commit("updateAgreement", this.agreement);
      },
      deep: true,
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/apps/hemmelig/components/form/Agreement.vue